import countryFamousPoint from '~/data/table/country_famous_point.json'

export const isExistCountryMap = (country) => {
  return country in countryFamousPoint
}
